import { Dialog } from "primereact/dialog";
import { ISubvendorInvoiceList } from "./Table";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";
interface IProps {
    open: boolean,
    singleData: ISubvendorInvoiceList,
    toast: any,
    onClose: () => void
}

const emailDescription = {
    subject: "Update on Pending Payment",
    body: `<p>Greetings,</p>
                                    <br/>
                                    <p>I hope you're doing well.</p>
                                    <br/>
                                    <p>I wanted to update you regarding the pending payment for @Invoice_Number (@FromDate  to  @ToDate), which is still under process. We understand the importance of timely payments and appreciate your patience.</p>
                                    <br/>
                                    <p>The delay has been due to the following reason(s):</p>
                              <br/>
                              <ul>
                                @reason
                              </ul>
                                    <br/>
                                    <p>Please be assured that we are actively working to resolve the issue(s), and we will keep you informed on the progress. We are aiming to clear the payment, and we will notify you immediately once it is processed.</p>
                                    <br/>
                                    <p>We sincerely apologize for the inconvenience and appreciate your continued cooperation.</p>
                                    <br/>
                                    <p>Best regards,</p>
                                    <br/>
                                    @Signature` };

export const NotPaidSVInvSendEmail = (props: IProps) => {
    const [reasons, setReasons] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const onHide = () => {
        setReasons("");
        setLoading(false);
        props.onClose();
    };

    const sendEmail = async () => {
        setLoading(true);
        const response = await Fetch("InvoiceTracking/sendEmailTForPaidInv", "POST", { reason: reasons }, `invoiceID=${props.singleData.id}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: 'Invoices updated successfully.', life: 3000 });
            setLoading(false);
            onHide();
        } else setLoading(false);
    }

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const generated_Date = (rowData: any) => {
        let date;
        if (rowData.generated_Date) date = format(new Date(rowData.generated_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const dueDate = (rowData: any) => {
        let date;
        if (rowData.dueDate) date = format(new Date(rowData.dueDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFromat = loginObj.date_Format;

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Send Email For Unpaid Invoices" modal className="p-fluid" onHide={onHide}>
                <div className="card" style={{ height: '55vh', overflowY: "scroll" }}>
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                        value={[props.singleData]}
                        stripedRows resizableColumns showGridlines columnResizeMode="expand"
                        dataKey="id"
                    >
                        <Column field="consultant_Name" header="Consultant Name" />
                        <Column field="vendor_Company_Name" header="Subvendor" />
                        <Column field="invoiceNO" header="Invoice NO" />
                        {/* <Column field="invoiceDate" header="Invoice Date" body={generated_Date} />
                        <Column field="fromDate" header="From Date" body={fromDate} />
                        <Column field="toDate" header="To Date" body={toDate} />
                        <Column field="dueDate" header="Due Date" body={dueDate} /> */}
                        <Column field="invoiceDate" header="Invoice Date" body={(rowData: any) => safeFormatDate(rowData.generated_Date, 'dd/MM/yyyy', DateFromat)} />
                        <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFromat)} />
                        <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFromat)} />
                        <Column field="dueDate" header="Due Date" body={(rowData: any) => safeFormatDate(rowData.dueDate, 'dd/MM/yyyy', DateFromat)} />
                    </DataTable>
                    <div className="flex gap-3 mt-3">
                        <div className="flex flex-column w-6 ml-3">
                            <label>To :</label>
                            <InputText value={`CONSULTANT : ${props.singleData.consultant_Email_ID}, SUBVENDOR : ${props.singleData.sub_Vendor_Contact_Person_Email}`} />
                        </div>
                        <div className="flex flex-column w-6 mr-3">
                            <label>CC :</label>
                            <InputText value={`SALES : ${props.singleData.salesEmailID}, RECRUITER : ${props.singleData.recruitersEmailID}`} />
                        </div>
                    </div>
                    <div className="flex justify-content-center flex-column pl-3 pr-3 mt-2">
                        <label>Any Reason You Want To Add :</label>
                        <InputText value={reasons} onChange={(e) => setReasons(e.target.value)} />
                    </div>
                    <div className="col-12 md:col-12 md:col-6">
                        <div className="flex justify-content-center flex-column mb-2">
                            <label>Subject :</label>
                            <InputText value={emailDescription.subject} />
                        </div>
                        <label htmlFor="body">Body<span style={{ color: 'red' }}>*</span></label>
                        <CKEditor editor={ClassicEditor} data={emailDescription.body} />
                    </div>
                </div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button loadingIcon={loading} disabled={loading} className="field col-12 md:col-4 h-2rem" label="SEND" onClick={() => sendEmail()} loading={loading}></Button>
                    <Button className="field col-12 md:col-4 h-2rem p-button-outlined" label="CANCEL" onClick={() => onHide()}></Button>
                </div>
            </Dialog>
        </>
    );
}